/**
 * The e-mail rule, extracted so the input and its CONSUMER can share it.
 *
 * `NxMailInput` deliberately does not render its own error — it exposes `isInvalid`
 * and lets the consumer place the message (see the component's own comment). But a
 * consumer that wants to REFUSE an invalid entry cannot read that flag: the input
 * derives it from its `modelValue` prop, which is exactly the value the consumer is
 * about to reject, so the flag would never flip. Such a consumer has to check the
 * incoming value itself — with this function, not a second copy of the pattern.
 */
const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]*[^\s@.]$/;

/** Empty counts as valid: "not filled in" is not the same as "wrong". */
export function isValidEmail(value: string | null | undefined): boolean {
  const v = value ?? '';
  return v.length === 0 || EMAIL_FORMAT.test(v);
}
